import { apiSlice } from "./baseApiSlice";
import handleDownloadFile from "../../utils/handleDownloadFile";

export type GetNegotiationExternalDataReportsResponse = NegotiationExternalDataReport[];
export interface NegotiationExternalDataReport {
  uuid: string;
  negotiation: string;
  document: any | null;
  data_source: string;
  data: object | null;
  external_code: number;
  state: 'P' | 'D' | 'E';
  domain: string | null;
}

export const externalDataReportSlice = apiSlice.injectEndpoints({
  endpoints: builder => {
    return ({
      getNegotiationExternalDataReports: builder.query<GetNegotiationExternalDataReportsResponse, string>({
        query: (negotiation_uuid) => `/negotiation/negotiations/${negotiation_uuid}/external-data-report/`,
        providesTags: (res, _err, arg) => (
          res ?
            [{ type: 'ExternalDataReports', id: arg }] :
            ["ExternalDataReports"]
        )
      }),
      createNegotiationExternalDataReport: builder.mutation<void, {
        negotiation_uuid: string,
        data_source: string,
        domain: string,
      }>({
        query: ({negotiation_uuid, data_source, domain}) => {
          return {
            url: `/negotiation/negotiations/${negotiation_uuid}/external-data-report/`,
            method: 'POST',
            body: {
              data_source,
              domain,
            },
            responseHandler: (response) => {
              if (data_source !== "ENGINEERING") {
                return handleDownloadFile(response);
              }

              return response.json();
            },
          }
        },
        invalidatesTags: (_res, _err, arg) => (
          [{ type: "ExternalDataReports", id: arg.negotiation_uuid }]
        ),
      }),
      patchNegotiationExternalDataReport: builder.mutation<void, {
        negotiation_uuid: string,
        external_data_report_uuid: string,
        redo: boolean,
        domain?: string,
      }>({
        query: (
          {
            negotiation_uuid,
            external_data_report_uuid,
            redo,
            domain
          }
        ) => {
          return {
            url: `/negotiation/negotiations/${negotiation_uuid}/external-data-report/${external_data_report_uuid}/`,
            method: "PATCH",
            body: {
              redo,
              domain
            }
          }
        },
        invalidatesTags: (_res, _err, arg) => (
          [{ type: "ExternalDataReports", id: arg.negotiation_uuid }]
        ),
      }),
      downloadNegotiationExternalDataReport: builder.query<Blob, {
        negotiation_uuid: string,
        external_data_report_uuid: string,
      }>({
        query: ({ negotiation_uuid, external_data_report_uuid }) => {
          return {
            url: `/negotiation/negotiations/${negotiation_uuid}/external-data-report/${external_data_report_uuid}/download/`,
            responseHandler: (response) => handleDownloadFile(response),
            cache: "no-cache",
          };
        }
      }),
    });
  }
});

export const {
  useGetNegotiationExternalDataReportsQuery,
  useCreateNegotiationExternalDataReportMutation,
  usePatchNegotiationExternalDataReportMutation,
  useLazyDownloadNegotiationExternalDataReportQuery,
} = externalDataReportSlice;
